import { format } from 'date-fns';
import messages from './messages.js';
import SelectAdminGroup from './SelectAdminGroup.jsx';

const schema = {
  id: 'addStudent',
  properties: [
    {
      id: 'firstName',
      type: 'text',
      label: messages.firstName,
      required: true,
    },
    {
      id: 'middleName',
      type: 'text',
      label: messages.middleName,
      attributes: { className: 'w-50' },
      required: false,
    },
    {
      id: 'lastName',
      type: 'text',
      label: messages.lastName,
      required: true,
    },
    {
      id: 'birthDate',
      type: 'date',
      label: messages.birthDate,
      placeholder: 'yyyy-mm-dd',
      attributes: { max: format(new Date(), 'yyyy-MM-dd') },
      required: true,
    },
    {
      id: 'yearClass',
      type: 'text',
      label: messages.yearClass,
      required: true,
    },
    {
      id: 'administrativeGroupId',
      as: SelectAdminGroup,
      label: messages.adminGroup,
      attributes: { className: 'w-100' },
      type: 'number',
    },
  ],
};

export default schema;
